define('constants/timeframeConstants',[], function() {
    return {
        today: 'today',
        thisWeek: 'this_week',
        thisMonth: 'this_month',
        thisQuarter: 'this_quarter',
        thisYear: 'this_year',
        yesterday: 'yesterday',
        lastWeek: 'last_week',
        lastMonth: 'last_month',
        lastQuarter: 'last_quarter',
        lastYear: 'last_year',
        monthToDate: 'month_to_date',
        quarterToDate: 'quarter_to_date',
        yearToDate: 'year_to_date',
        lastDays7: 'last_days_7',
        lastDays14: 'last_days_14',
        lastDays30: 'last_days_30',
        lastDays60: 'last_days_60',
        lastDays90: 'last_days_90',
        lastMonths12: 'last_months_12',
        custom: 'custom'
    };
});
